<template>
    <div class="row-min-space">
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': requiredFields,
            }"
        >
            <div class="row profile-setup">
                <div class="col-md-5 mb-20 dialling-code-field">
                    <isd-code
                        v-validate="{
                            required: requiredFields,
                        }"
                        :data-segment-id="dataSegmentId"
                        :field="{
                            association: 'countries',
                            isAssociation: true,
                            type: 'isd-code',
                            isLocked: true,
                            isRequired: requiredFields,
                            label: 'Dialing code',
                            placeholder: 'Dialing code',
                            options: [],
                            key: isdKey,
                            customerDetails: this.field.customerDetails?this.field.customerDetails:null,
                            disabled:isDisabled
                        }"
                        text-field="isdCodeTitle"
                        value-field="isdCode"
                        :multiple="false"

                        name="Dialing Code"
                        :class="{
                            'is-invalid': errors.has('Dialing Code'),
                        }"
                    ></isd-code>
                </div>
                <div class="col-md-7">
                    <!-- max: maxPhoneNoLength, -->
                    <b-form-input
                        v-model="model"
                        v-validate="{
                            required: requiredFields,
                            min: 8,
                            regex: /^([0-9]*)$/,
                        }"
                        type="tel"
                        max-length="10"
                        placeholder="Enter phone number"
                        data-vv-name="phone number"
                        :readonly="readOnly"
                        :disabled="isDisabled"
                        :class="{
                            'is-invalid': errors.has('phone number'),
                        }"
                    ></b-form-input>
                </div>
            </div>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
import IsdCode from './IsdCode'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        IsdCode,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
        dataSegmentId: {
            type: String,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            readOnly:false,
            textField: 'title',
            valueField: '_id',
            isDisabled:false,
            country:process.env.VUE_APP_COUNTRY,
            fieldsToCheck:[
                {
                    field:'minorAccountInfo.phoneNumber',
                    dependency:'minorAccountInfo.isMinorAccount'
                },
                {
                    field:'minorAccountInfo.isdCode',
                    dependency:'minorAccountInfo.isMinorAccount'
                },
                {
                    field:'jointAccountInfo.phoneNumber',
                    dependency:'jointAccountInfo.isJointAccount'
                },
                {
                    field:'jointAccountInfo.isdCode',
                    dependency:'jointAccountInfo.isJointAccount'
                },
            ],

        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        isdKey()
        {
            let tempKey = this.field.key
            if(tempKey.includes('.'))
            {
                tempKey= tempKey.split('.')
                if(tempKey.length > 2)
                {
                    return `${tempKey[0]}.${tempKey[1]}.isdCode`
                }
                else
                {
                    return `${tempKey[0]}.isdCode`
                }
            }

        },
        maxPhoneNoLength() {
            if (this.field.key == 'contactInfo.phoneNumber') {
                if (process.env.VUE_APP_COUNTRY == 'United Arab Emirates') {
                    return 9
                } else if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                    return 10
                } else {
                    return 11
                }
            }
        },
        requiredFields()
        {
            return this.field.isRequired
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */

    created() {
        if(this.$store.state.registration.form.uaePassDetails)
        {
            if(this.field.key == 'contactInfo.phoneNumber' && this.$store.state.registration.form.uaePassDetails.mobile)
            {
                this.readOnly=true
            }
        }
        const fieldFound = this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key);
        if (fieldFound) {

            this.$store.watch(
                (state) => {
                    let fieldName = fieldFound.dependency.split('.')
                    return this.$store.state.registration.form[fieldName[0]][fieldName[1]] // could also put a Getter here

                },
                (newValue, oldValue) => {
                    if (newValue == 'yes') {
                        this.isDisabled = false

                    } else {
                        this.model=''
                        this.isDisabled = true
                    }
                }
            )
        }
    },

    mounted() {
        const fieldFound = this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key);
        if(fieldFound)
        {
            let fieldName = fieldFound.dependency.split('.')
            if(this.$store.state.registration.form[fieldName[0]][fieldName[1]]=='yes')
            {
                this.isDisabled = false
            }
            else
            {
                this.isDisabled = true
            }
        }

    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
